import {curatedCardsSwiper} from './curated-cards-swiper';
import {imageCardsSwiper} from './image-cards-swiper';
import {profileCardsSwiper} from './profile-cards-swiper';
import {blockquoteSwiper} from './blockquote-swiper';
import {testimonialBlockAwards} from './testimonial-block-awards';

curatedCardsSwiper();
imageCardsSwiper();
profileCardsSwiper();
blockquoteSwiper();
testimonialBlockAwards();
